import { render, staticRenderFns } from "./RubroCreateUpdate.vue?vue&type=template&id=219dac34&"
import script from "./RubroCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./RubroCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports